import { Close, Folder } from '@mui/icons-material';
import { Box, Button, FormControl, Grid, IconButton, InputLabel, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'

const SociosOrganismo = ({ data, setDatos, errores, }) => {
    const [catalogoFiguras, setCatalogoFiguras] = useState([]);
    useEffect(() => {
        const init = async () => {
            try {
                await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/figuras_juridicas_es`)
                    .then(res => res.json())
                    .then((respuesta) => {
                        setCatalogoFiguras(respuesta.data);
                    });
            } catch (error) {

            }
        }
        init();
    }, []);
    const addFigura = () => {
        setDatos({
            target: {
                name: 'socios',
                value: [
                    ...data.socios,
                    {
                        figura_juridica: '',
                        n_empresas: '', // empresas u organizaciones sociales
                        n_personas: '' // personas asociadas    
                    }
                ]
            }
        })
    }
    const handleFigura = (e, index) => {
        // si el valor es "otro", habilitar un campo libre.
        // actualizar valor del listado
        let newData = data.socios.map((s, i) => {
            if (i == index) {
                s.figura_juridica = e.target.value
            }
            return s
        })
        setDatos({ target: { name: 'socios', value: newData } })
    }

    const handleInput = (e, gal = false) => {
        let imagen = e.target.files[0] ?? null;
        if (imagen) {
            const reader = new FileReader();
            reader.onload = (readerEvent) => {
                imagen.dataurl = readerEvent.target.result
                setDatos({ target: { name: 'imagenes', value: [...data.imagenes, imagen], } });
            };
            reader.readAsDataURL(imagen);
        }
    }
    const handleQtys = (e, type, index) => {
        let newData = data.socios.map((s, i) => {
            if (i == index) {
                s[type] = parseInt(e.target.value)
            }
            return s
        })
        setDatos({ target: { name: 'socios', value: newData } });
    }
    const removeImg = (imgurl) => {
        setDatos({ target: { name: 'imagenes', value: data.imagenes.filter(img => img.dataurl !== imgurl) } });
    }
    return (
        <div>
            <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                    <Typography variant="h5">Total de Socios de la organización</Typography>
                    <Grid container spacing={2}>
                        {data.socios.map((socio, index) => (
                            <Grid item xs={12} key={index}>
                                <Box>
                                    <FormControl fullWidth error={errores.includes('figura_juridica')} margin="normal">
                                        <InputLabel id="figura_juridica" required>Figura Jurídica {index + 1} de las empresas u organizaciones</InputLabel>
                                        <Select
                                            labelId="figura_juridica"
                                            name="figura_juridica"
                                            value={socio.figura_juridica}
                                            label={`Figura Jurídica ${index + 1} de las empresas u organizaciones`}
                                            onChange={(e) => handleFigura(e, index)}
                                        >
                                            {/* Obtener catalogo de figuras jurídicas */}
                                            {catalogoFiguras.map((figura) => (
                                                <MenuItem key={figura.id} value={figura.id}>
                                                    {figura.nombre}
                                                </MenuItem>
                                            ))}
                                            <MenuItem key="otro" value="otro">Otro</MenuItem>
                                        </Select>
                                    </FormControl>
                                    <Stack direction="row" spacing={1}>
                                        <TextField
                                            fullWidth
                                            onChange={(e) => handleQtys(e, 'n_empresas', index)}
                                            value={socio.n_empresas}
                                            label="Cantidad de empresas u organizaciones sociales"
                                            type="number"
                                            margin="normal"
                                        />
                                        <TextField
                                            fullWidth
                                            onChange={(e) => handleQtys(e, 'n_personas', index)}
                                            value={socio.n_personas}
                                            label="Cantidad de personas asociadas"
                                            type="number"
                                            margin="normal"
                                        />
                                    </Stack>

                                </Box>
                            </Grid>
                        ))}
                        <Grid item xs={12}>
                            <Button onClick={addFigura} variant="contained" fullWidth>
                                Agregar figura
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} xs={12}>
                    <Box sx={{ mx: 2, pt: 2 }}>
                        <Typography variant="h6">Fotogalería de las Empresas u Organizaciones afiliadas al Organismo*</Typography>
                        <Typography variant="subtitle1">(Máximo 20 fotografías)</Typography>
                    </Box>
                    <Grid container spacing={2} sx={{ mx: 2, mt: 2 }}>
                        {data.imagenes.map((image) => (
                            <Grid item xs key={image.name} sx={{ position: 'relative', mr: 2, mb: 2, border: 1, borderColor: '#e0dcda', p: 1, display: 'flex', alignItems: 'center' }}>
                                <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0 }} onClick={() => removeImg(image.dataurl)}>
                                    <Close />
                                </IconButton>
                                <img src={image.dataurl} alt={image.name} width="150px" />
                            </Grid>
                        ))}
                    </Grid>
                    <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
                        <Button disabled={data.imagenes.length > 19} component="label" variant="contained" startIcon={<Folder />}>
                            Agregar <input name="imagen" onInputCapture={(e) => handleInput(e, true)} type="file" accept='image/*' hidden />
                        </Button>
                    </Box>
                </Grid>
            </Grid>


        </div>
    )
}

export default SociosOrganismo